import Sortable from 'sortablejs'

/*
「.js-○○」直下の「.js-○○-item」を並び替える。
「.js-○○-up」「.js-○○-down」で上下の入れ替え、「.js-○○-handle」を掴むとドラッグで入れ替え。

<div class="js-○○">
    <div class="js-○○-item">
        <div class="info__ui">
            <div class="js-○○-handle">
            </div>
            <button type="button" class="js-○○-up">
            </button>
            <button type="button" class="js-○○-down">
            </button>
        </div>
    </div>
</div>
*/
window.sortSetup = function () {
  listDrug('groupSort')
  listDrug('blockSort')
}

window.sortSetup() // 並び替え処理の初期化

function listDrug(name = 'drugSort') {
  // フレーム要素
  const frameItemList = document.querySelectorAll('.js-' + name + ':not(.sortSetup-complete)')
  if (!frameItemList[0]) {
    // フレームが無ければ終了
    return
  }

  for (const frameItem of frameItemList) {
    const api = frameItem.dataset.sortApi // APIのURL
    const sortable = new Sortable(frameItem, {
      handle: '.js-' + name + '-handle', // ハンドル要素
      filter: '.js-' + name + '-disable', // ドラッグを禁止する要素
      ghostClass: 'js-' + name + '-drop', // ドロップ中のクラス名の指定
      chosenClass: 'js-' + name + '-select', // 選択中のクラス名の指定
      dragClass: 'js-' + name + '-grip', // ドラッグ中のクラス名の指定
      animation: 150,
      scroll: true,
      // onEnd: function (e) {}, // ドラッグが終了した時
      // setData:function(e){} // データを格納・保存した時
      // onChoose:function(e){} // 要素を選択している時
      // onStart:function(e){} // ドラッグが開始された時
      onEnd: function (e) {
        console.log(api)
        if (api) {
          let param = 'type=sort&id='
          const itemList = frameItem.querySelectorAll('.js-sortVal')

          for (let index = 0; index < itemList.length; index++) {
            const element = itemList[index]
            if (index !== 0) {
              param += ','
            }
            param += element.value
          }
          applyAjax(api, 'post', param)
        }
      }, // ドラッグが終了した時
      // onAdd:function(e){} // リスト内に新たに要素が追加された時
      // onUpdate:function(e){} // ソートされリスト内が新たに更新された時
      // onSort:function(e){} // リストの変更（追加/更新/削除）がされた時
      // onRemove:function(e){} // 要素がリストから別のリストに移動し削除された時
      // onFilter:function(e){} // filterで指定された要素をドラッグしようとした時
      // onMove:function(e){} // リスト内またはリスト間で項目を移動した時
      // onClone:function(e){} // 要素が複製された時
    })

    frameItem.classList.add('sortSetup-complete')
  }

  //            #####   ######  ##     ##
  //            ##  ##    ##    ####   ##
  //  ########  #####     ##    ##  ## ##
  //            ##  ##    ##    ##    ###
  //            #####     ##    ##     ##
  // ボタン操作による入れ替え
  window.addEventListener('click', function (e) {
    let direction = null
    let btn = e.target.closest('.js-' + name + '-up')
    if (btn) {
      direction = 'up'
    }
    btn = e.target.closest('.js-' + name + '-down')
    if (btn) {
      direction = 'down'
    }
    if (!direction) {
      return
    }

    const item = e.target.closest('.js-' + name + '-item')
    const frameItem = e.target.closest('.js-' + name)

    shiftBtn(frameItem, item, direction)
  })

  //    ###        ##    ###    ##    ##
  //   ## ##       ##   ## ##    ##  ##
  //  ##   ##      ##  ##   ##    ####
  //  #######  ##  ##  #######   ##  ##
  //  ##   ##   ####   ##   ##  ##    ##

  let ajax
  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param method {string} get/post
   * @param param {string} 送信パラメータ
   */
  function applyAjax(url, method = 'get', param) {
    if (ajax) {
      // 既に通信中なら切断
      ajax.abort()
    }

    ajax = new XMLHttpRequest() // Ajaxリクエスト
    if (method === 'post') {
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    } else {
      if (param) {
        url += (~url.indexOf('?') ? '&' : '?') + param // パラメータをURLに結合
      }
      // Ajaxと明示するパラメータを付ける
      url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    }
    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    // ajax.setRequestHeader('Pragma', 'no-cache')
    // ajax.setRequestHeader('Cache-Control', 'no-cache')
    // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
    if (method === 'post') {
      ajax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー
    }
    ajax.responseType = 'document' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間
    if (method === 'post') {
      ajax.send(param) // POSTリクエスト実行
    } else {
      ajax.send() // GETリクエスト実行
    }
    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー
      }

      // // IEは取得タイプJSONをtextで受け取るのでJSONにパースする
      // if (navigator.userAgent.indexOf('Trident') !== -1 && JSON) {
      //   ajaxData = JSON.parse(ajaxData)
      // }
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
    }
    ajax.onerror = function () {
      // Ajax処理失敗
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      // intObsAjax()
      ajax = false
    }
  }
}
function shiftBtn(frameItem, item, direction = 'up') {
  let shiftTarget = null

  if (frameItem.childElementCount < 2) {
    // アイテムが複数個なければキャンセル
    return
  }
  if (direction === 'up') {
    shiftTarget = item.previousElementSibling
    if (!shiftTarget) {
      frameItem.appendChild(item) // 一番下へ
      return
    }
    frameItem.insertBefore(item, shiftTarget)
    return
  } else {
    shiftTarget = item.nextElementSibling
    if (!shiftTarget) {
      frameItem.prepend(item)
      return
    }
    frameItem.insertBefore(shiftTarget, item)
    return
  }
}
